import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    companyName: '',
    supplierId: '',
    userType: '',
    countryCode: '',
    reported: '',
    goalsSubmitted: '',
    filteredData: []
};

const supplierSearchSlice = createSlice({
    name: 'supplierSearch',
    initialState,
    reducers: {
        setCompanyName: (state, action) => {
            state.companyName = action.payload;
        },
        setSupplierId: (state, action) => {
            state.supplierId = action.payload;
        },
        setUserType: (state, action) => {
            state.userType = action.payload;
        },
        setCountryCode: (state, action) => {
            state.countryCode = action.payload;
        },
        setFilteredData: (state, action) => {
            state.filteredData = action.payload;
        },
        setReported: (state, action) => {
            state.reported = action.payload;
        },
        setGoalsSubmitted: (state, action) => {
            state.goalsSubmitted = action.payload;
        }
    }
});

export const {
    setCompanyName,
    setSupplierId,
    setUserType,
    setCountryCode,
    setFilteredData,
    setReported,
    setGoalsSubmitted
} = supplierSearchSlice.actions;

export default supplierSearchSlice.reducer;
